<template>
	<div class="game-nav-bar nav-bar">
		<div class="left">
			<h4>
				<a @click="emitLeave" class="leave tc-secondary">Leave game</a>
			</h4>
			<h4 v-if="gameId">Room {{ gameId }}</h4>
		</div>
		<div class="right">
			<div class="options-menu">
				<div class="options-container">
					<button
						class="show-hide"
						:class="{ active: showUserPreferences }"
						@click="showUserPreferences = !showUserPreferences"
					>
						user preferences
					</button>
					<div v-if="showUserPreferences" class="options">
						<button
							v-for="(value, key) in userPreferences"
							:key="key"
							class="option"
							:class="{ active: value }"
							@click="userToggleOption(key)"
						>
							{{ key }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
	data() {
		return {
			showUserPreferences: false,
		};
	},
	props: ["gameId"],
	computed: {
		...mapGetters(["userPreferences"]),
	},
	methods: {
		...mapActions(["userToggleOption"]),
		emitLeave() {
			this.$emit("try-leave");
		},
	},
};
</script>

<style lang="scss">
@import "../assets/scss/main.scss";
.game-nav-bar {
	position: absolute;
}
.nav-bar {
	.left,
	.right {
		display: flex;
		align-items: flex-start;
		flex-direction: row;
		gap: 12px;
	}
}
$active: rgb(29, 150, 83);
$option-grey: rgb(105, 110, 122);
.options-menu {
	display: flex;

	.options-container {
		z-index: 9;
		text-align: right;
		button {
			color: white;
			margin: 0 4px;
			padding: 4px 8px;
			cursor: pointer;
			transition: 0.2s;
			&:hover {
				background-color: lighten($option-grey, 5%);
			}
			background-color: $option-grey;
		}
		.show-hide {
			box-shadow: 0px 2px rgba(0, 0, 0, 0.2);
			&.active {
				box-shadow: 0px -2px rgba(0, 0, 0, 0.2);
				transform: translateY(1px);
				background-color: darken($option-grey, 10%);
			}
			border-radius: 3px;
		}

		.options {
			margin-top: 8px;
			display: block;
			text-align: right;
			.option {
				display: block;
				box-shadow: 0px 2px rgba(0, 0, 0, 0.2);
				color: white;
				margin: 0 4px;
				padding: 4px 8px;
				&.active {
					background-color: $active;
					&:hover {
						background-color: lighten($active, 5%);
					}
				}
				&:active {
					box-shadow: 0px -2px rgba(0, 0, 0, 0.2);
					transform: translateY(1px);
					background-color: darken($option-grey, 10%);
				}
				&.hover-green:hover {
					background-color: $active;
				}
				&:first-child {
					border-radius: 3px 3px 0px 0px;
				}
				&:last-child {
					border-radius: 0px 0px 3px 3px;
				}
			}
		}
	}
}
.leave {
	cursor: pointer;
	transition-duration: $trd-s;
	&:hover {
		color: lighten($blue-lightest, 10%);
	}
}
</style>
